import { DefaultSiteIcon } from '@euler/app/flows/task/pages/inspection/components/DefaultSiteIcon';
import { Center } from '@euler/components/Center';
import { Img } from '@euler/components/image/AdvancedImage';
import { sentry } from '@euler/lib/integration/sentry';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Crypto from 'expo-crypto';
import { memo, useEffect, useState } from 'react';
import { ActivityIndicator, Image, StyleProp } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';

export const SiteIcon = memo(
  ({
    url,
    type,
    color,
    size,
    style,
  }: {
    url?: string;
    type?: 'image' | 'svg';
    size: number;
    color: string;
    style?: StyleProp<ImageStyle>;
  }) => {
    const [svgXml, setSvgXml] = useState<string>();
    const [svgUrl, setSvgUrl] = useState<string>();

    useEffect(() => {
      if (!url || !type || type === 'image') return;
      Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.MD5, url)
        .then(async hash => {
          const key = `site-icon:${hash}`;
          const value = await AsyncStorage.getItem(key);
          if (value != null) {
            setSvgXml(value);
            return;
          }
          // load the content of the svg file.
          const resp = await fetch(url);
          if (resp.ok) {
            const content = await resp.text();
            await AsyncStorage.setItem(key, content);
            setSvgXml(content);
          } else {
            // fallback to the svg url;
            setSvgUrl(url);
          }
        })
        .catch(e => {
          sentry.captureException(e);
          // fallback to the svg url;
          setSvgUrl(url);
        });
    }, [url, type]);

    if (!url || !type) {
      return <DefaultSiteIcon size={size} color={color} style={style} />;
    }

    if (type === 'svg') {
      if (svgXml) {
        const dataUri = `data:image/svg+xml;utf8,${encodeURIComponent(svgXml)}`;
        return (
          <Image
            source={{ uri: dataUri }}
            width={size}
            height={size}
            style={style as any}
          />
        );
      }

      if (svgUrl) {
        return (
          <Image
            source={{ uri: svgUrl }}
            width={size}
            height={size}
            style={style as any}
          />
        );
      }

      return (
        <Center
          css={`
            width: ${size}px;
            height: ${size}px;
          `}
          style={style}
        >
          <ActivityIndicator size="small" color={color} />
        </Center>
      );
    }

    return (
      <Img
        uri={url}
        resizeMode="contain"
        css={`
          width: ${size}px;
          height: ${size}px;
        `}
        style={style}
      />
    );
  },
);
